import { render, staticRenderFns } from "./MailConfirmation.vue?vue&type=template&id=3992fb6a&scoped=true"
import script from "./MailConfirmation.vue.js?vue&type=script&lang=js&external"
export * from "./MailConfirmation.vue.js?vue&type=script&lang=js&external"
import style0 from "./MailConfirmation.vue?vue&type=style&index=0&id=3992fb6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992fb6a",
  null
  
)

export default component.exports